import { IPatientScopedFact, ITimestampedFact } from './common';

export interface IPatientEventFact
  extends IPatientScopedFact,
    ITimestampedFact {}
